// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e6c47c10","732":"4943d719","977":"68529333"}[chunkId] + ".chunk.js";
};